import { PrimeReactStylesFunctionType } from '../types';
import { classNames } from 'primereact/utils';

export const InputNumberTailwindThemes = {
  inputnumber: {
    root: 'w-full inline-flex',
    input: {
      root: ({ props }: PrimeReactStylesFunctionType) => ({
        className: classNames({
          'rounded-tr-none rounded-br-none': props.showButtons && props.buttonLayout == 'stacked',
        }),
      }),
    },
    buttongroup: ({ props }: PrimeReactStylesFunctionType) => ({
      className: classNames({ 'flex flex-col': props.showButtons && props.buttonLayout == 'stacked' }),
    }),
    incrementbutton: ({ props }: PrimeReactStylesFunctionType) => ({
      className: classNames('flex !items-center !justify-center', {
        'rounded-br-none rounded-bl-none !p-0 flex-1 w-[3rem]': props.showButtons && props.buttonLayout == 'stacked',
      }),
    }),
    decrementbutton: ({ props }: PrimeReactStylesFunctionType) => ({
      className: classNames('flex !items-center !justify-center', {
        'rounded-tr-none rounded-tl-none !p-0 flex-1 w-[3rem]': props.showButtons && props.buttonLayout == 'stacked',
      }),
    }),
  },
};
